module.exports = __webpack_public_path__ + "img/rn.c0676b61.png";